import { ClarionButton } from '@clarion/ClarionButton';
import NonIdealPage from '../util/NonIdealPage';
import { signOut } from './UserState';

export default function LoadError() {
  return (
    <NonIdealPage
      icon="warning-sign"
      title="Unable to load Recap"
      description="Check your internet connection and try again. If that doesn’t work, please log out and log back in."
      action={
        <div className="flex flex-wrap justify-center gap-2">
          <ClarionButton onClick={() => window.location.reload()}>Try again</ClarionButton>
          <ClarionButton onClick={signOut}>Log out</ClarionButton>
        </div>
      }
    />
  );
}
